class ActionRegistry {
    constructor() {
        this.handlers = new Map();
    }
    register(name, handler) {
        if (this.handlers.has(name)) {
            console.warn(`[ActionRegistry] Overwriting handler for ${name}`);
        }
        this.handlers.set(name, handler);
    }
    get(name) {
        return this.handlers.get(name);
    }
}
export const actionRegistry = new ActionRegistry();
//maybe this should live somewhere else
/** Minimal dot-path resolver for strings like '@data.name' / '@label' / '@type' */
export function resolveParams(spec, ctx) {
    const resolveString = (s) => {
        var _a;
        if (!s.startsWith('@'))
            return s;
        const path = s.slice(1); // remove '@'
        switch (path) {
            case 'label': return ctx.orb.labelText;
            case 'type': return ctx.orb.orbType;
            case 'uuid': return (_a = ctx.orb.group) === null || _a === void 0 ? void 0 : _a.uuid;
        }
        if (path.startsWith('data.')) {
            return getPath(ctx.orb.jsonData, path.substring('data.'.length));
        }
        if (path.startsWith('orb.')) {
            return getPath(ctx.orb, path.substring('orb.'.length));
        }
        if (path.startsWith('scene.')) {
            const sc = ctx.scene;
            if (!sc)
                return undefined;
            return getPath(sc, path.substring('scene.'.length));
        }
        return undefined;
    };
    if (typeof spec === 'string')
        return resolveString(spec);
    if (Array.isArray(spec)) {
        return spec.map(v => resolveParams(v, ctx));
    }
    if (spec && typeof spec === 'object') {
        const out = {};
        for (const [k, v] of Object.entries(spec)) {
            out[k] = resolveParams(v, ctx);
        }
        return out;
    }
    return spec;
}
function getPath(obj, path) {
    return path.split('.').reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
}
